/* eslint-disable no-shadow */
export var POST_FORMAT_TYPES;
(function (POST_FORMAT_TYPES) {
    POST_FORMAT_TYPES["TEXT"] = "text";
    POST_FORMAT_TYPES["VIDEO"] = "video";
    POST_FORMAT_TYPES["GALLERY"] = "gallery";
    POST_FORMAT_TYPES["CAROUSEL"] = "carousel";
})(POST_FORMAT_TYPES || (POST_FORMAT_TYPES = {}));
export const formatMap = {
    text: POST_FORMAT_TYPES.TEXT,
    video: POST_FORMAT_TYPES.VIDEO,
    gallery: POST_FORMAT_TYPES.GALLERY,
    carousel: POST_FORMAT_TYPES.CAROUSEL
};
